export default "/images/7652668bc285bc9633032954769b01a2.avif";